/**
 * Time formatting utilities
 */

/**
 * Format longer durations as minutes and show seconds during the final minute.
 */
export function formatTime(seconds) {
  if (seconds === 'Unlimited') {
    return 'Unlimited';
  }
  const wholeSeconds = Math.max(0, Math.floor(Number(seconds)));
  if (wholeSeconds < 60) {
    return `0:${String(wholeSeconds).padStart(2, '0')}`;
  }
  const mins = Math.floor(wholeSeconds / 60);
  return `${mins} minute${mins !== 1 ? 's' : ''}`;
}
